<app-tabs-header [labelText]="'Search provider network by name'"
                 [iconName]="'add'"
                 [showButton]="true"
                 [buttonText]="'Add Provider Network'"
                 [navigateTo]="'/enterprise-management/add-provider-network'"
                 (valueChanged)="onValueChanged($event)">
</app-tabs-header>

<div class="mat-elevation-z8 table-container">
  <table mat-table multiTemplateDataRows [dataSource]="providerNetworkDataSource"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        
        <mat-icon class="table-icon" matTooltip="EDIT Provider Network"
                  (click)="editEntry($event, row)">
          edit
        </mat-icon>
        
        <mat-icon class="table-icon" matTooltip="DELETE Provider Network"
                  (click)="onDeleteProviderNetworkConfirmation($event, row)"
                  [ngClass]="{'disabled': !hasPermissionsBasedOnRole}">
          delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="providerNetworkId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
      <td *matCellDef="let row" mat-cell>{{row.providerNetworkId}}</td>
    </ng-container>
  
    <ng-container matColumnDef="code">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Code</th>
      <td *matCellDef="let row" mat-cell>{{row.code}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
      <td *matCellDef="let row" mat-cell>{{row.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="administrator">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Administrator</th>
      <td *matCellDef="let row" mat-cell>{{row.administrator?.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="startDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
      <td *matCellDef="let row" mat-cell>{{row.startDate | date: dateFormat}}</td>
    </ng-container>
    
    <ng-container matColumnDef="endDate">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
      <td *matCellDef="let row" mat-cell>{{row.endDate | date: dateFormat}}</td>
    </ng-container>
    
    <!-- Expanded Row -->
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="providerNetworkDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == providerNetworkExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          <b>Grading </b>{{row.grading}}<br>
        </div>
      </td>
    </ng-container>
    
    
    <tr mat-header-row *matHeaderRowDef="providerNetworkDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: providerNetworkDisplayedColumns;"
        class="row" [class.expanded-row]="providerNetworkExpandedRow == row"
        (click)="providerNetworkExpandedRow = providerNetworkExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  </table>
  
  <mat-paginator #providerNetworkPaginator (page)="pageChanged($event)"
                 [length]="providerNetworkTableControl.length" [pageSize]="providerNetworkTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="providerNetworkTableControl.pageSizeOptions">
  </mat-paginator>

</div>
